import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

async function update(axios: AxiosInstance, type: string): Promise<object & { id: number; subject_id: number }> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/task/assign-next?type=${type}`);
  return data;
}

export default function useAssignNextTaskMutation(type: string) {
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: () => update(axios, type),
    onError: (error: any) => {
      manageErrorResponse(toast, error);
    },
  });
}
